module.exports = __webpack_public_path__ + "img/etho-1b4b7dac-bebd-41c4-4899-08d95b7e528f.png";